import {
  AssigneesProjectResponseType,
  RestAPI,
  useCoordinator,
  WorkType,
} from '@builddocs/data-management'
import { useQuery } from 'react-query'

interface IUseGetAssignees {
  workType: WorkType
  assigneeType: string
  actId: string
}

export function useGetAssignees({
  workType,
  assigneeType,
  actId,
}: IUseGetAssignees) {
  const { projectId, contractId } = useCoordinator() as {
    projectId: string
    contractId: string
  }

  return useQuery({
    queryFn: () =>
      RestAPI.get<AssigneesProjectResponseType[]>(`/contractassignees`, {
        params: {
          journalId: contractId,
          workType,
          assigneeTypeAct: assigneeType,
          actId,
        },
      }).then(res => res.data),
    // заменить AOSR на тип акта после добавления фичи к вторичным актам
    queryKey: [
      'assignees',
      projectId,
      contractId,
      workType,
      actId,
      assigneeType,
    ],
    select: data =>
      data.map(assignee => ({
        ...assignee,
        positionDescription: assignee.position ?? assignee.positionDescription,
      })),
  })
}
